import { createRouter, createWebHistory } from 'vue-router'
import authService from '../auth/oidc'
import HomeView from '../views/HomeView.vue'
import AuthCallbackView from '../views/AuthCallbackView.vue'
import FinancialEntityTypesView from '../views/FinancialEntityTypesView.vue'
import PaymentMethodsView from '../views/PaymentMethodsView.vue'
import AccountTypesView from '../views/AccountTypesView.vue'
import DocumentTypesView from '../views/DocumentTypesView.vue'
import ChargeTypesView from '../views/ChargeTypesView.vue'
import FinancialEntitiesView from '../views/FinancialEntitiesView.vue'
import BankAccountsView from '../views/BankAccountsView.vue'
import LedgerAccountsView from '../views/LedgerAccountsView.vue'
import FinancialDocumentsView from '../views/FinancialDocumentsView.vue'
import FinancialDocumentFormView from '../views/FinancialDocumentFormView.vue'
import InstallmentAgendaView from '../views/InstallmentAgendaView.vue'
import ManualPaymentView from '../views/ManualPaymentView.vue'
import PaymentsView from '../views/PaymentsView.vue'
import PaymentDetailView from '../views/PaymentDetailView.vue'
import PaymentOrdersView from '../views/PaymentOrdersView.vue'
import PaymentOrderFormView from '../views/PaymentOrderFormView.vue'
import PaymentOrderDetailView from '../views/PaymentOrderDetailView.vue'
import PaymentApprovalsView from '../views/PaymentApprovalsView.vue'
import RecurrencesView from '../views/RecurrencesView.vue'
import RecurrenceFormView from '../views/RecurrenceFormView.vue'
import RecurrenceDetailView from '../views/RecurrenceDetailView.vue'
import ChargesView from '../views/ChargesView.vue'
import ChargeFormView from '../views/ChargeFormView.vue'
import ChargeDetailView from '../views/ChargeDetailView.vue'
import ReconciliationView from '../views/ReconciliationView.vue'
import BankAutomationView from '../views/BankAutomationView.vue'
import PaymentAdjustmentsView from '../views/PaymentAdjustmentsView.vue'
import AdvancedReportsView from '../views/AdvancedReportsView.vue'
import MessageOperationsView from '../views/MessageOperationsView.vue'
import PaymentAllocationsView from '../views/PaymentAllocationsView.vue'
import LedgerView from '../views/LedgerView.vue'
import LedgerConfigurationView from '../views/LedgerConfigurationView.vue'
import ProviderConfigurationsView from '../views/ProviderConfigurationsView.vue'
import financialAccessService from '../services/financialAccessService'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/callback', name: 'AuthCallback', component: AuthCallbackView, meta: { public: true, hideLayout: true } },
    {
      path: '/home',
      name: 'Home',
      component: HomeView,
      meta: { requiresAuth: true, headerTitle: 'Painel executivo', headerSubtitle: 'Visão consolidada da operação financeira' }
    },
    {
      path: '/obrigacoes',
      name: 'FinancialDocuments',
      component: FinancialDocumentsView,
      meta: { requiresAuth: true, moduleCode: 'OBLIGATIONS', accessLevel: 1, headerTitle: 'Obrigações e pagamentos', headerSubtitle: 'Documentos financeiros e vencimentos' }
    },
    {
      path: '/obrigacoes/nova',
      name: 'FinancialDocumentNew',
      component: FinancialDocumentFormView,
      meta: { requiresAuth: true, moduleCode: 'OBLIGATIONS', accessLevel: 2, headerTitle: 'Obrigações e pagamentos', headerSubtitle: 'Inclusão de documento financeiro' }
    },
    {
      path: '/obrigacoes/:id(\\d+)',
      name: 'FinancialDocumentDetail',
      component: FinancialDocumentFormView,
      meta: { requiresAuth: true, moduleCode: 'OBLIGATIONS', accessLevel: 1, headerTitle: 'Obrigações e pagamentos', headerSubtitle: 'Detalhe do documento financeiro' }
    },
    {
      path: '/obrigacoes/:id(\\d+)/editar',
      name: 'FinancialDocumentEdit',
      component: FinancialDocumentFormView,
      meta: { requiresAuth: true, moduleCode: 'OBLIGATIONS', accessLevel: 2, headerTitle: 'Obrigações e pagamentos', headerSubtitle: 'Edição de documento em rascunho' }
    },
    {
      path: '/agenda-parcelas',
      name: 'InstallmentAgenda',
      component: InstallmentAgendaView,
      meta: { requiresAuth: true, moduleCode: 'INSTALLMENT_AGENDA', accessLevel: 1, headerTitle: 'Agenda de parcelas', headerSubtitle: 'Vencimentos, saldos e baixas financeiras' }
    },
    {
      path: '/pagamentos',
      name: 'Payments',
      component: PaymentsView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENTS', accessLevel: 1, headerTitle: 'Pagamentos', headerSubtitle: 'Consulta e rastreabilidade de movimentações' }
    },
    {
      path: '/pagamentos/:id(\\d+)',
      name: 'PaymentDetail',
      component: PaymentDetailView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENTS', accessLevel: 1, headerTitle: 'Pagamentos', headerSubtitle: 'Detalhe, baixas e histórico' }
    },
    {
      path: '/pagamentos/novo',
      name: 'ManualPaymentNew',
      component: ManualPaymentView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENTS', accessLevel: 2, headerTitle: 'Obrigações e pagamentos', headerSubtitle: 'Registro manual de pagamento confirmado' }
    },
    {
      path: '/cobrancas',
      name: 'Charges',
      component: ChargesView,
      meta: { requiresAuth: true, moduleCode: 'CHARGES', accessLevel: 1, headerTitle: 'Cobranças', headerSubtitle: 'Emissão, acompanhamento e recebimentos' }
    },
    {
      path: '/cobrancas/nova',
      name: 'ChargeNew',
      component: ChargeFormView,
      meta: { requiresAuth: true, moduleCode: 'CHARGES', accessLevel: 2, headerTitle: 'Cobranças', headerSubtitle: 'Emissão de cobrança' }
    },
    {
      path: '/cobrancas/:id(\\d+)',
      name: 'ChargeDetail',
      component: ChargeDetailView,
      meta: { requiresAuth: true, moduleCode: 'CHARGES', accessLevel: 1, headerTitle: 'Cobranças', headerSubtitle: 'Detalhe, pagamentos e cancelamento' }
    },
    {
      path: '/programacoes-pagamento',
      name: 'PaymentOrders',
      component: PaymentOrdersView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENT_ORDERS', accessLevel: 1, headerTitle: 'Programações de pagamento', headerSubtitle: 'Agenda operacional e aprovação opcional' }
    },
    {
      path: '/programacoes-pagamento/nova',
      name: 'PaymentOrderNew',
      component: PaymentOrderFormView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENT_ORDERS', accessLevel: 2, headerTitle: 'Programações de pagamento', headerSubtitle: 'Nova programação' }
    },
    {
      path: '/programacoes-pagamento/:id(\\d+)',
      name: 'PaymentOrderDetail',
      component: PaymentOrderDetailView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENT_ORDERS', accessLevel: 1, headerTitle: 'Programações de pagamento', headerSubtitle: 'Detalhe e execução' }
    },
    {
      path: '/aprovacoes-pagamento',
      name: 'PaymentApprovals',
      component: PaymentApprovalsView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENT_APPROVALS', accessLevel: 1, headerTitle: 'Aprovações de pagamento', headerSubtitle: 'Fila de decisões pendentes' }
    },
    {
      path: '/recorrencias',
      name: 'Recurrences',
      component: RecurrencesView,
      meta: { requiresAuth: true, moduleCode: 'RECURRENCES', accessLevel: 1, headerTitle: 'Recorrências', headerSubtitle: 'Geração periódica de obrigações' }
    },
    {
      path: '/recorrencias/nova',
      name: 'RecurrenceNew',
      component: RecurrenceFormView,
      meta: { requiresAuth: true, moduleCode: 'RECURRENCES', accessLevel: 2, headerTitle: 'Recorrências', headerSubtitle: 'Nova regra recorrente' }
    },
    {
      path: '/recorrencias/:id(\\d+)/editar',
      name: 'RecurrenceEdit',
      component: RecurrenceFormView,
      meta: { requiresAuth: true, moduleCode: 'RECURRENCES', accessLevel: 2, headerTitle: 'Recorrências', headerSubtitle: 'Edição da regra' }
    },
    {
      path: '/recorrencias/:id(\\d+)',
      name: 'RecurrenceDetail',
      component: RecurrenceDetailView,
      meta: { requiresAuth: true, moduleCode: 'RECURRENCES', accessLevel: 1, headerTitle: 'Recorrências', headerSubtitle: 'Regra e histórico de execuções' }
    },
    {
      path: '/conciliacao',
      name: 'Reconciliation',
      component: ReconciliationView,
      meta: { requiresAuth: true, moduleCode: 'RECONCILIATION', accessLevel: 1, headerTitle: 'Conciliação bancária', headerSubtitle: 'Extratos, correspondências e divergências' }
    },
    {
      path: '/automacao-bancaria',
      name: 'BankAutomation',
      component: BankAutomationView,
      meta: { requiresAuth: true, moduleCode: 'BANK_AUTOMATION', accessLevel: 1, headerTitle: 'Automação bancária', headerSubtitle: 'Fila segura e idempotente de programações' }
    },
    {
      path: '/automacao-bancaria/provedores',
      name: 'ProviderConfigurations',
      component: ProviderConfigurationsView,
      meta: { requiresAuth: true, moduleCode: 'PROVIDER_CONFIGURATION', accessLevel: 1, headerTitle: 'Provedores de pagamento', headerSubtitle: 'Contas, identificadores e credenciais referenciadas' }
    },
    {
      path: '/estornos-reembolsos',
      name: 'PaymentAdjustments',
      component: PaymentAdjustmentsView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENT_ADJUSTMENTS', accessLevel: 1, headerTitle: 'Estornos e reembolsos', headerSubtitle: 'Correções financeiras com preservação do histórico' }
    },
    {
      path: '/baixas-rateios',
      name: 'PaymentAllocations',
      component: PaymentAllocationsView,
      meta: { requiresAuth: true, moduleCode: 'PAYMENT_ALLOCATIONS', accessLevel: 1, headerTitle: 'Baixas e rateios', headerSubtitle: 'Distribuição, reversão e realocação de pagamentos' }
    },
    {
      path: '/relatorios-gerenciais',
      name: 'AdvancedReports',
      component: AdvancedReportsView,
      meta: { requiresAuth: true, moduleCode: 'ADVANCED_REPORTS', accessLevel: 1, headerTitle: 'Relatórios gerenciais', headerSubtitle: 'Posição financeira, aging e fluxo de caixa' }
    },
    {
      path: '/mensageria',
      name: 'MessageOperations',
      component: MessageOperationsView,
      meta: { requiresAuth: true, moduleCode: 'MESSAGE_OPERATIONS', accessLevel: 1, headerTitle: 'Mensageria', headerSubtitle: 'Outbox, inbox, dead letters e reprocessamentos' }
    },
    {
      path: '/ledger',
      name: 'Ledger',
      component: LedgerView,
      meta: { requiresAuth: true, moduleCode: 'LEDGER', accessLevel: 1, headerTitle: 'Ledger', headerSubtitle: 'Partidas balanceadas, saldos e rastreabilidade financeira' }
    },
    {
      path: '/ledger/configuracoes',
      name: 'LedgerConfiguration',
      component: LedgerConfigurationView,
      meta: { requiresAuth: true, moduleCode: 'LEDGER_CONFIGURATION', accessLevel: 1, headerTitle: 'Ledger', headerSubtitle: 'Configuração e mapeamento do plano de contas' }
    },
    {
      path: '/cadastros/tipos-entidade-financeira',
      name: 'FinancialEntityTypes',
      component: FinancialEntityTypesView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Estruturas fundamentais do sistema' }
    },
    {
      path: '/cadastros/metodos-pagamento',
      name: 'PaymentMethods',
      component: PaymentMethodsView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Estruturas fundamentais do sistema' }
    },
    {
      path: '/cadastros/tipos-conta',
      name: 'AccountTypes',
      component: AccountTypesView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Estruturas fundamentais do sistema' }
    },
    {
      path: '/cadastros/tipos-documento',
      name: 'DocumentTypes',
      component: DocumentTypesView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Estruturas fundamentais do sistema' }
    },
    {
      path: '/cadastros/tipos-cobranca',
      name: 'ChargeTypes',
      component: ChargeTypesView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Estruturas fundamentais do sistema' }
    },
    {
      path: '/cadastros/entidades-financeiras',
      name: 'FinancialEntities',
      component: FinancialEntitiesView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Participantes da operação financeira' }
    },
    {
      path: '/cadastros/contas-bancarias',
      name: 'BankAccounts',
      component: BankAccountsView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Contas reais vinculadas às entidades' }
    },
    {
      path: '/cadastros/contas-ledger',
      name: 'LedgerAccounts',
      component: LedgerAccountsView,
      meta: { requiresAuth: true, headerTitle: 'Cadastros financeiros', headerSubtitle: 'Estrutura interna de movimentação de valores' }
    },
    { path: '/:pathMatch(.*)*', redirect: '/home' }
  ]
})

router.beforeEach(async to => {
  if (!to.meta.requiresAuth) return true
  if (!await authService.isAuthenticated()) {
    await authService.signInRedirect(to.fullPath)
    return false
  }
  if (to.meta.moduleCode && !await financialAccessService.has(to.meta.moduleCode, to.meta.accessLevel || 1)) return '/home'
  return true
})

export default router
